import {
  cloudChiprApi,
  PostOrganisationsCurrentAccountsResourceTypesStatusesApiResponse,
} from "@/services/cloudchipr.api";
import { getLiveUsageResourcesTypeStatusesFixedCacheKey } from "@/store/live-usage-mgmt/thunks/resources/resource-info-status/getLiveUsageResourcesTypeStatusesThunk";
import { RootState } from "@/store/store";
import { liveUsageMgmtAccountIdsSelector } from "@/store/live-usage-mgmt/selectors/store-selectors/liveUsageMgmtAccountIdsSelector";

const endpointSelector = (accountIds: string[] | null) =>
  cloudChiprApi.endpoints.postOrganisationsCurrentAccountsResourceTypesStatuses.select(
    getLiveUsageResourcesTypeStatusesFixedCacheKey(accountIds),
  );

export const postOrganisationsCurrentAccountsResourceTypesStatusesSelector = (
  state: RootState,
):
  | PostOrganisationsCurrentAccountsResourceTypesStatusesApiResponse
  | undefined => {
  const accountIds = liveUsageMgmtAccountIdsSelector(state);

  const response = endpointSelector(accountIds)(state);

  return response?.data;
};
